import { createApi } from '@reduxjs/toolkit/query/react'
import { createAdminBaseQuery } from '../../../Utils/baseQuery'

export const adminApiService = createApi({
  reducerPath: 'adminApi',
  baseQuery: createAdminBaseQuery('/admin/'),
  endpoints: (builder) => ({
    getAdminProfile: builder.query({
      query: () => 'profile',
      keepUnusedDataFor: 0
    }),
    getAdmins: builder.query({
      query: () => 'list',
      keepUnusedDataFor: 0
    }),
    createAdmin: builder.mutation({
      query: (payload) => ({
        url: 'create',
        method: 'POST',
        body: payload
      })
    }),
    updateAdmin: builder.mutation({
      query: ({ id, payload }) => ({
        url: `update/${id}`,
        method: 'PUT',
        body: payload
      })
    }),
    changePassword: builder.mutation({
      query: (payload) => ({
        url: 'change-password',
        method: 'POST',
        body: payload
      })
    }),
    deactivateAdmin: builder.mutation({
      query: (id) => ({
        url: `deactivate/${id}`,
        method: 'PATCH'
      })
    })
  })
})

export const {
  useGetAdminProfileQuery,
  useLazyGetAdminProfileQuery,
  useGetAdminsQuery,
  useLazyGetAdminsQuery,
  useCreateAdminMutation,
  useUpdateAdminMutation,
  useChangePasswordMutation,
  useDeactivateAdminMutation
} = adminApiService
